import { MentionMe } from './mention-me'
import { Referee } from './referee'
import { Referrer } from './referrer'

export const ReferFriend = MentionMe

ReferFriend.Referee = Referee
ReferFriend.Referrer = Referrer
